<template>
  <footer class="app-footer text-center">
    <span>
      <a href="https://edutore.com"> CMS Ebooks </a>
      &copy; {{ year }} By Gramedia
    </span>
  </footer>
</template>
<script>
import moment from "moment";
export default {
  name: "footers",
  data() {
    return {
      year: ""
    };
  },
  mounted() {
    this._actionYear();
  },
  methods: {
    _actionYear() {
      return (this.year = moment().format("YYYY"));
    }
  }
};
</script>
<style>
.heart {
  fill: red;
  position: relative;
  height: 20px;
  top: 5px;
  margin-bottom: 8px;
  width: 50px;
  animation: pulse 1.5s ease infinite;
}
.app-footer {
  font-family:"Avenir Next" ,"effra", Helvetica, Arial, sans-serif;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
